function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVesselFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h2a1 1 0 0 1 1 1v3.909l1.58.45a1 1 0 0 1 .635 1.376l-1.86 4.093A2 2 0 0 1 19.535 24h-7.07a2 2 0 0 1-1.82-1.172l-1.86-4.093a1 1 0 0 1 .636-1.375L11 16.909V13a1 1 0 0 1 1-1h2V9zm1 3h2V9h-2v3zm-3 4.623l3.725-1.065a1 1 0 0 1 .55 0L20 16.623V13h-8v3.623zm4-.103l-6.305 1.801 1.86 4.093a1 1 0 0 0 .91.586h7.07a1 1 0 0 0 .91-.586l1.86-4.093L16 16.52z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVesselFront);
export default __webpack_public_path__ + "static/media/vessel-front.7e934ba2aa4a298c93b2b711c8c249f1.svg";
export { ForwardRef as ReactComponent };